export const getPercentDiff = (current: number, previous: number) => {
  const diff = current - previous;
  return previous === 0 ? 0 : Number.parseFloat(((Math.abs(diff) / previous) * 100).toFixed(2));
};
